"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
const useStyles = slideBy => {
  const {
    fontFamily
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    scrollProps
  } = (0, _hooks.useStylesUtils)();
  const ccSwimLaneStyle = (0, _react.useMemo)(() => {
    const ccSwimLane = (0, _css.css)({
      fontFamily,
      position: 'relative',
      paddingInlineEnd: pxToRem(64),
      overflowX: slideBy === 'scroll' ? 'auto' : 'unset',
      ...scrollProps(slideBy)
    });
    const ccArrowButtonWrapper = rotate => ({
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      top: 0,
      bottom: 0,
      zIndex: 2,
      pointerEvents: 'none',
      marginBottom: pxToRem(55)
    });
    const ccArrowLeftButtonWrapper = (0, _css.css)({
      ...ccArrowButtonWrapper(90),
      left: 0
    });
    const ccArrowRightButtonWrapper = (0, _css.css)({
      ...ccArrowButtonWrapper(270),
      right: 0
    });
    const ccArrowButtonContainer = (0, _css.css)({
      width: pxToRem(64),
      height: pxToRem(64)
    });
    const ccArrowButton = {
      background: '#ffffff 0% 0% no-repeat padding-box',
      boxShadow: `0 0 ${pxToRem(7)} ${pxToRem(3)} rgb(0 0 0 / 45%)`
    };
    const ccLeftArrowButton = {
      ...ccArrowButton,
      transform: 'rotate(90deg)'
    };
    const ccRightArrowButton = {
      ...ccArrowButton,
      transform: 'rotate(270deg)'
    };
    const ccArrowButtonContent = (0, _css.css)({
      width: '100%',
      height: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: pxToRem(70),
        height: pxToRem(70)
      }
    });
    const ccSwimLaneItems = (0, _css.css)({
      display: 'flex',
      overflowX: 'visible',
      transform: 'translateX(0)',
      transition: slideBy === 'item' ? 'transform 0.25s cubic-bezier(0.47, 0, 0.75, 0.72)' : 'transform 1s cubic-bezier(0.47, 0, 0.75, 0.72)'
    });
    const ccSwimLaneItem = (0, _css.css)({
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexShrink: 0,
      flexGrow: 0,
      marginInlineEnd: pxToRem(30)
    });
    return {
      ccSwimLane,
      ccArrowLeftButtonWrapper,
      ccArrowRightButtonWrapper,
      ccArrowButtonContainer,
      ccLeftArrowButton,
      ccRightArrowButton,
      ccArrowButtonContent,
      ccSwimLaneItems,
      ccSwimLaneItem
    };
  }, [slideBy, fontFamily, pxToRem, scrollProps]);
  return {
    'cc-SwimLane': ccSwimLaneStyle.ccSwimLane,
    'cc-SwimLane__button-left-wrapper': ccSwimLaneStyle.ccArrowLeftButtonWrapper,
    'cc-SwimLane__button-right-wrapper': ccSwimLaneStyle.ccArrowRightButtonWrapper,
    'cc-SwimLane__button-container': ccSwimLaneStyle.ccArrowButtonContainer,
    'cc-SwimLane__button-left': ccSwimLaneStyle.ccLeftArrowButton,
    'cc-SwimLane__button-right': ccSwimLaneStyle.ccRightArrowButton,
    'cc-SwimLane__button-content': ccSwimLaneStyle.ccArrowButtonContent,
    'cc-SwimLane__items': ccSwimLaneStyle.ccSwimLaneItems,
    'cc-SwimLane__item': ccSwimLaneStyle.ccSwimLaneItem
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;